export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-baas.vue?vue&type=template&id=3c08120a"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-baas.vue?vue&type=template&id=3c08120a
// module id = 4Qe2
// module chunks = 0